import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useIntl } from 'react-intl'
import { updateMultiCartComment } from 'api/cart/updateMultiCartComment'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { COMMENT_QUERY_KEY } from 'constants/comments'

interface UpdateCommentParams {
  multiCartId: string
  commentId: string
  text: string
}

export function useUpdateMultiCartComment() {
  const queryClient = useQueryClient()
  const intl = useIntl()

  return useMutation({
    mutationFn: (params: UpdateCommentParams) => updateMultiCartComment(
      params.multiCartId,
      params.commentId,
      params.text,
    ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [COMMENT_QUERY_KEY, variables.multiCartId] })
    },
    onError: (error: Error) => {
      showSnackbar(intl.formatMessage({
        id: 'CQb4dPwqsGBZ-10b9cN9',
        defaultMessage: 'Failed to update comment: {errorMessage}',
        description: 'Snackbar error message when updating a shared cart comment fails',
      }, { errorMessage: error.message }), 'critical')
    },
  })
}
